import styled from "styled-components"
import { CardStyle, CloseIcon } from "buoy-core"
import { responsive, colors } from "buoy-theme"

const FilterCard = styled.section`
  ${CardStyle};
  margin: 24px 0;
  ${props => !props.clarifier &&
    responsive("margin-bottom", "100px", "100px", "40px", "40px", "40px")}
  padding: 16px;
  width: 100%;
  float: right;
  position: relative;
`

CloseIcon.defaultProps = {
  color: colors.primary,
  padding: "11px",
  hoverColor: "primaryLightest",
  size: "40px",
  iconSize: "18px",
  top: "5px",
  right: "5px",
  backgroundSize: "45px"
}

export { FilterCard as default, CloseIcon }



// WEBPACK FOOTER //
// ./assets/filters/components/FilterCard.js